import { Memo } from 'src/models/memo';

import { Callback } from 'src/util/query/models/Callback';

export class MemoCallback extends Callback<Memo> {
	public constructor(private readonly setMemo: (memo: Memo | null) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Memo): void => {
		this.setMemo(successResponse);
	};
}
